import React from "react";
import "./GetMusicOn7Digital.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOn7Digital = () => {

  const steps = [
    "Create your FTTunes account",
    "Upload music & artwork",
    "Deliver music to 7digital",
    "Get your music approved",
    "Reach global stores & services",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>Get Your Music on 7digital | FT Tunes Distribution</title>

        <meta
          name="description"
          content="Distribute your music on 7digital with FT Tunes. Reach global download stores, telecom platforms and digital entertainment services worldwide."
        />

        <meta
          name="keywords"
          content="7digital distribution, upload music to 7digital, FT Tunes distribution, global music distribution"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="sevendigital-page">

        {/* HERO */}
        <section className="sevendigital-hero">
          <Container>

            <img
              src="/Images/7-digital-logo.png"
              alt="7digital logo"
              className="sevendigital-logo"
            />

            <h1>Get Your Music on 7digital</h1>

            <p>
              Distribute your music worldwide through 7digital’s global
              music delivery network. Reach download stores, telecom
              platforms, fitness apps, gaming services and digital
              entertainment ecosystems across international markets.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-sevendigital"></div>
        </section>


        {/* SHOWCASE */}
        <section className="sevendigital-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Expand Your Global Reach</h2>

                <p>
                  7digital connects artists to worldwide digital music
                  services beyond traditional streaming platforms,
                  helping your music reach new listeners globally.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Distribute Now
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-music-on-7-digital.png"
                  alt="7digital music distribution"
                  className="sevendigital-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="sevendigital-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="sevendigital-benefits">
          <Container>

            <h2 className="section-title">
              Built For Independent Artists
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Global Distribution</h5>
                  <p>Deliver music to worldwide platforms.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>High Quality Audio</h5>
                  <p>Professional delivery standards.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Royalty Earnings</h5>
                  <p>Earn from downloads and streams.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>100% Ownership</h5>
                  <p>You keep full rights to your music.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="sevendigital-cta">
          <Container>

            <h2>Start Growing on 7digital Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Upload Your Music
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOn7Digital;